import { useEffect, useState } from "react";
import { ErrorContext } from "../../utils/context/error";
import { getPermisoAll } from "../../services/permission";
import IconM from "../dashboard/menu/icons/Icon";
import PermissionModal from "./permissionmodal";
import useTable from "../../hooks/table";
import TableFooter from "../../hooks/table/footer";


function Permission ()
 {
    const { setShowToast, setOpciones } = ErrorContext();
    const [MenuId, setMenuId] = useState(0);
    const [ItemId, setItemId] = useState(0);
    const [showM, setShowM] = useState(false);
    const [tag, setTag] = useState(0);
    const [selectedRow, setSelectedRow] = useState(null);
    const [Permisos, setPermisos] = useState([]);
    const [page, setPage] = useState(1);
    const { slice, range } = useTable(Permisos, page, 10);  
      
    //-----------------------------------------------------------------
    const fillPermisos = async() =>
      {
        const response = await getPermisoAll();  
        if (response) 
          {
            if (response.status === 200) 
              {
                setPermisos(response.data.data);
              } 
            else 
            {
              const Mensaje = response.message;
              const opc = { type: "Danger", message: Mensaje, active: true };
              setOpciones(opc);
              setShowToast(true);
            }
          }
      }    
    
    //--------------------------------------------------------------------  
    const handleCrearPerm =(tagId)=>
      {
         if ((selectedRow === null) && (tagId !== 0)) return
         if (tagId === 0) 
          {
             setMenuId(0);
             setItemId(0);
          }
          setShowM(true);
         setTag(tagId);
      }
    
    //----------------------------------------------------------------------
    const handlefilas = (item, index) => 
      {
        setSelectedRow(index);
        setMenuId(item.MenuId);
        setItemId(item.ItemId);
      };
    
    //----------------------------------------------------------------------
    useEffect(() => 
      {
        fillPermisos();
      }, []);
         
      return (
        <>
          <div className="">
              <div className="paneltitle">
                 <label className="text-[1.0rem] font-light text-gray-400 leading-none"> Administración/Digiturno/Pantalla</label>
              </div>
              
             <div className="panelmenu">
                <button className="btnmenu" onClick={() => handleCrearPerm(0)} >
                    <IconM svg="newfile" className="iconmenu" title="newfile" />
                    <span>Nuevo</span>
                </button>
            
                <button className="btnmenu" id="Editar" disabled={selectedRow === null} onClick={() => handleCrearPerm(1)}>
                   <IconM svg="pencil" className="iconmenu" title="pencil" />
                   <span>Editar</span>
                </button>
       
                <button className="btnmenu" id="Eliminar" onClick={() => handleCrearPerm(2)} disabled={selectedRow === null}>
                   <IconM svg="delfile" className="iconmenu" title="delfile" />
                   <span>Eliminar</span>
                </button>
             </div>
             <div className="mt-2 rounded-lg border border-stone-200 overflow-x-auto">
                 <table className="w-full table-auto min-w-[700px]">
                    <thead className="border-b border-stone-200 text-sm font-medium ">
                       <tr>
                          <th className="hidden md:table-cell px-2.5 py-2 text-start font-medium">Id.</th>
                          <th className="px-2.5 py-2 text-start font-medium">Programa</th>
                          <th className="px-2.5 py-2 text-start font-medium">Item Id</th>
                          <th className="px-2.5 py-2 text-start font-medium">
                            Opción
                          </th>
                          <th className="px-2.5 py-2 text-start font-medium">Nombre</th>
                       </tr>
                    </thead>
                    <tbody className="group text-sm text-stone-800 ">
                      {slice.map((item, index) => {
                         return (
                            <tr className={`border-b border-stone-200 last:border-0 ${selectedRow === index ? 'bg-blue-50 selected cursor-pointer' : ''}`} key={index} id={`fila${item.ConsultID}`} onClick={() => handlefilas(item, index)}>
                              <td className="hidden md:table-cell">{item.MenuId}</td>
                              <td>{item.NombreMenu}</td>
                              <td>{item.ItemId}</td>
                              <td>{item.CodigoItem}</td>
                              <td>{item.NombreItem}</td>
                           </tr>
                          )})}
                     </tbody>
                  </table>
               </div>
               <TableFooter range={range} slice={slice} setPage={setPage} page={page} /> 

      </div>
      <PermissionModal
        show={showM}
        MenuI={MenuId}
        ItemI={ItemId}
        Tag={tag}
        handleshow={setShowM}
        fillPermisos={fillPermisos}
      ></PermissionModal>
    </>
  );    

}

export default Permission;